const alphanumeric = (value: string): string => value && value.replace(/[^A-Za-z0-9_]/g, '');

export default alphanumeric;
